var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 11.6667C1.66667 11.6667 1.76777 12.3744 4.6967 15.3033C7.62564 18.2322 12.3744 18.2322 15.3033 15.3033C16.341 14.2656 17.0111 12.9994 17.3135 11.6667M1.66667 11.6667V16.6667M1.66667 11.6667H6.66667M18.3333 8.33333C18.3333 8.33333 18.2322 7.62563 15.3033 4.6967C12.3744 1.76777 7.62564 1.76777 4.6967 4.6967C3.65898 5.73443 2.98892 7.0006 2.68653 8.33333M18.3333 8.33333V3.33333M18.3333 8.33333H13.3333",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.d6fb65caeb73b06d4bceaedabf50f7f5.svg";
export { ForwardRef as ReactComponent };